module.exports = __webpack_public_path__ + "static/media/skincare_female.03c617a4.svg";